import React from 'react';
import { FaWhatsapp, FaPhone } from 'react-icons/fa';
import './FloatingButtons.css';

const FloatingButtons = () => {
  return (
    <div className="floating-buttons">
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/919894065756"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp-btn"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp />
        <span className="btn-tooltip">Chat on WhatsApp</span>
      </a>

      {/* Call Button */}
      <a
        href="tel:9894065756"
        className="floating-btn call-btn"
        aria-label="Call Us"
      >
        <FaPhone />
        <span className="btn-tooltip">Call Now</span>
      </a>
    </div>
  );
};

export default FloatingButtons;
